'use client';

import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';
const TRACK_HEIGHT = 4;
const THUMB_SIZE = 14;
const StyledSliderRoot = styled(Slider)(({
  theme
}) => ({
  color: theme.palette.primary.main,
  height: TRACK_HEIGHT,
  padding: '28px 0 24px',
  '& .MuiSlider-rail': {
    height: TRACK_HEIGHT,
    opacity: 1,
    backgroundColor: theme.palette.grey[200],
    borderRadius: 1
  },
  '& .MuiSlider-track': {
    height: TRACK_HEIGHT,
    border: 'none',
    borderRadius: 1,
    backgroundColor: theme.palette.primary.main
  },
  '& .MuiSlider-thumb': {
    width: THUMB_SIZE,
    height: THUMB_SIZE,
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey[300]}`,
    boxShadow: 'none',
    '&:hover, &.Mui-focusVisible': {
      boxShadow: `0 0 0 4px ${theme.palette.primary.main}29`
    },
    '&.Mui-active': {
      boxShadow: `0 0 0 6px ${theme.palette.primary.main}29`
    },
    '&::before': {
      display: 'none'
    }
  },
  '& .MuiSlider-valueLabel': {
    fontSize: 11,
    fontWeight: 500,
    lineHeight: 1.2,
    padding: '2px 6px',
    backgroundColor: theme.palette.common.white,
    // grey[900] stays dark in both modes; text.primary is light on dark theme
    color: theme.palette.grey[900],
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 4,
    top: -6,
    transform: 'translateY(-100%) scale(1) !important',
    '&::before': {
      display: 'none'
    },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translateY(-100%) scale(1)'
    }
  },
  '& .MuiSlider-markLabel': {
    fontSize: '0.65rem',
    color: theme.palette.text.secondary,
    top: 36
  },
  '&.Mui-disabled': {
    color: theme.palette.grey[400],
    '& .MuiSlider-track': {
      backgroundColor: theme.palette.grey[400]
    },
    '& .MuiSlider-rail': {
      backgroundColor: theme.palette.grey[100]
    },
    '& .MuiSlider-thumb': {
      backgroundColor: theme.palette.common.white,
      borderColor: theme.palette.grey[300]
    },
    '& .MuiSlider-valueLabel': {
      color: theme.palette.text.disabled,
      borderColor: theme.palette.grey[300]
    }
  }
}));

/**
 * MUI Slider styled to match the product mock:
 * white bordered thumb, always-on value chip, thin blue/gray track.
 */
export const StyledSlider = forwardRef(function StyledSlider({
  valueLabelDisplay = 'on',
  ...props
}, ref) {
  return <StyledSliderRoot ref={ref} valueLabelDisplay={valueLabelDisplay} {...props} />;
});